export enum HOLIDAYS {
  ADD_VACATION_BTN = "addVacationBtn",
  ADD_VACATION_CLEANING_RADIO_NO = "addVacationCleaningRadioNo",
  ADD_VACATION_CLEANING_RADIO_YES = "addVacationCleaningRadioYes",
  HOLIDAYS_SKIP_CLEANINGS_MODAL = "skipCleaningsModal",
  MAX_DAYS_EXCEEDED_MSG = "maxDaysExceeded",
}
